import { useNavigate, useLocation } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import React, { useEffect, useState, useRef } from "react";
import { showError, showToast } from "../../constants/toasts";
import {
  useDeleteUserByIdMutation,
  useLazyGetCustomerQuery,
  useUpdateStatusMutation,
} from "../../services/customer";
import { Box, Tab, Tabs } from "@mui/material";
import BookingList from "../../features/manageCustomers/customerList";
import OwnerList from "../../features/manageCustomers/ownerList";
import { ConfirmationModal } from "../../Modals/ConfirmationModal";
import { GET_CUSTOMER } from "../../types/General";
import Loader from "../../constants/Loader";
import useAuth from "../../hooks/useAuth";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageCustomers = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const user = useAuth();
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [valueTabs1, setValueTabs1] = React.useState(1);
  const [open, setOpen] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedIdUser, setSelectedIdUser] = useState("");
  const [count, setCount] = useState(0);
  const [userData, setUserData] = useState<GET_CUSTOMER[]>([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [getUser] = useLazyGetCustomerQuery();
  const [deleteUser] = useDeleteUserByIdMutation();
  const [updatedStatus] = useUpdateStatusMutation();
  const [valueTabs, setValueTabs] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const skipLoadingRef = useRef(false);
  const totalCount = count;
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage);
  };

  useEffect(() => {
    if (location.state && typeof location.state.tab === "number") {
      setValueTabs(location.state.tab);
    }
  }, []);

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    skipLoadingRef.current = true;
    setValueTabs(newValue);
  };

  const handleOwnerSubTabChange = (newValue: number) => {
    skipLoadingRef.current = true;
    setValueTabs1(newValue);
  };

  const getUserApi = async () => {
    if (!skipLoadingRef.current) setLoading(true);
    try {
      const role = valueTabs === 0 ? "USER" : "OWNER";
      const response = await getUser({
        from: page,
        search: searchTerm,
        role,
        size: 10,
        accountStatus:
          valueTabs1 == 0
            ? "PENDING"
            : valueTabs1 == 1
            ? "APPROVED"
            : "REJECTED",
        country: user?.accessRoleId?.country || "",
      } as any).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        setUserData(response?.data?.data);
        setCount(response?.data?.total);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    } finally {
      skipLoadingRef.current = false;
    }
  };
  const deleteVehicleApi = async (id: string) => {
    setLoading(true);
    try {
      const response = await deleteUser({
        id,
      }).unwrap();
      setLoading(false);
      if (response?.statusCode === 200) {
        showToast(response?.message || "User Deleted Successfully");
        getUserApi();
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };
  const handleStatusUpdate = async (id: string, status: boolean) => {
    const body = {
      isBlocked: status,
    };

    try {
      const response = await updatedStatus({ body, id }).unwrap();
      if (response?.statusCode === 200) {
        showToast(`User ${!status ? "activated" : "deactivated"} successfully`);
        getUserApi();
      } else {
        showError("Please try again");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };
  useEffect(() => {
    getUserApi();
  }, [valueTabs, valueTabs1, page, count, searchTerm,user]);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage User/Owner</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> - Manage
          Bookings
        </p>
      </div>
      <div className="cards" style={{ position: "relative" }}>
        <Loader isLoad={loading} />
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="user-owner tabs"
            className="custom_tabs_links"
          >
            <Tab label="User" {...a11yProps(0)} />
            <Tab label="Owner" {...a11yProps(1)} />
          </Tabs>
          <CustomTabPanel value={valueTabs} index={0}>
            <BookingList
              searchTerm={searchTerm}
              userData={userData}
              setOpen1={setOpen}
              setSelectedId={setSelectedId}
              setSelectedIdUser={setSelectedIdUser}
              totalCount={totalCount}
              page={page}
              handlePageChange={handlePageChange}
              handleStatusUpdate={handleStatusUpdate}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              setSearchTerm={setSearchTerm}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <OwnerList
              userData={userData}
              valuesTabs={valueTabs1}
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              setSearchTerm={setSearchTerm}
              setValueTabs={handleOwnerSubTabChange}
              setSelectedId={setSelectedId}
              setOpen={setOpen}
              totalCount={totalCount}
              page={page}
              handlePageChange={handlePageChange}
              getUserApi={getUserApi}
              searchTerm={searchTerm}
            />
          </CustomTabPanel>
        </Box>
        <ConfirmationModal
          text={
            selectedIdUser
              ? "Are you sure you want to delete the User?"
              : "Are you sure you want to delete the Owner?"
          }
          openModal={open}
          setOpenModal={setOpen}
          handleSubmit={() => deleteVehicleApi(selectedIdUser || selectedId)}
        />
      </div>
    </MainContainer>
  );
};

export default ManageCustomers;
